export default __webpack_public_path__ + "static/media/1830.bef2cd76.png";